import React from "react";
import { EditPayment } from ".";
import { DisplayBox, Loading } from "../../components";
import { ApiHelper, DateHelper, PaymentInterface, UserHelper } from "../../helpers";

interface Props {

}

export const Credits: React.FC<Props> = props => {

  const [payments, setPayments] = React.useState<PaymentInterface[]>(null);
  const [selectedPayment, setSelectedPayment] = React.useState<PaymentInterface>(null);


  const init = () => {
    ApiHelper.get("/payments/unused").then((data: PaymentInterface[]) => setPayments(data));
  }

  React.useEffect(init, [])


  const getTable = () => {
    if (payments === null) return <Loading />
    else {
      if (payments.length === 0) return <p>There are no active credits</p>
      else {
        const formatter = Intl.NumberFormat("en-US", { style: "currency", currency: "USD" });

        const rows: JSX.Element[] = [];
        payments.forEach(p => {
          const payment = p;
          const dateEl = (UserHelper.checkAccess("admin"))
            ? <a href="about:blank" onClick={(e) => { e.preventDefault(); setSelectedPayment(payment) }}>{DateHelper.prettyDate(DateHelper.convertToDate(p.paymentDate))}</a>
            : <>{DateHelper.prettyDate(DateHelper.convertToDate(p.paymentDate))}</>
          rows.push(<tr>
            <td>{dateEl}</td>
            <td>{formatter.format(p.amount)}</td>
            <td>{formatter.format(p.unusedAmount)}</td>
          </tr>)

        });
        return (<table className="table table-sm table-striped">
          <thead>
            <tr><th>Date</th><th>Amount</th><th>Remaining</th></tr>
          </thead>
          <tbody>{rows}</tbody>
        </table>)
      }
    }
  }

  const getPaymentDetails = () => {
    if (selectedPayment) return <EditPayment payment={selectedPayment} onClose={() => { setSelectedPayment(null); init(); }} />
  }

  const newPayment = () => {
    setSelectedPayment({ accountId: UserHelper.currentDepartment.accountId, amount: 0, method: "card", paymentDate: new Date() });
  }

  if (payments?.length > 0 || UserHelper.checkAccess("admin")) {
    return (
      <>
        {getPaymentDetails()}
        <DisplayBox headerText="Credits" headerIcon="fa fa-money" >
          {getTable()}
          {(UserHelper.checkAccess("admin") && <a href="about:blank" onClick={(e) => { e.preventDefault(); newPayment(); }}>Add Credit</a>)}
        </DisplayBox>
      </>
    );
  } else return <></>
};